import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
  variant?: 'horizontal' | 'vertical';
}

export default function ArticleCard({ article, variant = 'vertical' }: ArticleCardProps) {
  if (variant === 'horizontal') {
    return (
      <Link
        to={`/article/${article.slug}`}
        className="group flex gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
      >
        <div className="w-40 sm:w-48 flex-shrink-0 aspect-video rounded-md overflow-hidden bg-background-200">
          <img
            src={article.coverImage}
            alt={article.title}
            title={article.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
        </div>
        <div className="flex flex-col justify-between min-w-0 flex-1">
          <div>
            <div className="flex items-center gap-2 mb-1">
              <span className="px-2 py-0.5 text-xs bg-secondary-100 text-secondary-700 rounded">
                {article.category}
              </span>
              <span className="text-xs text-foreground-400">{article.date}</span>
            </div>
            <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2">
              {article.title}
            </h3>
            <p className="text-xs text-foreground-500 mt-1 line-clamp-2">
              {article.summary}
            </p>
          </div>
          <div className="flex items-center gap-3 text-xs text-foreground-400 mt-2">
            <span>{article.author}</span>
            <span>{article.readTime}阅读</span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="aspect-video overflow-hidden bg-background-200">
        <img
          src={article.coverImage}
          alt={article.title}
          title={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
      </div>
      <div className="p-4">
        <div className="flex items-center gap-2 mb-2">
          <span className="px-2 py-0.5 text-xs bg-accent-100 text-accent-700 rounded">
            {article.category}
          </span>
          <span className="text-xs text-foreground-400">{article.date}</span>
        </div>
        <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2">
          {article.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-2 line-clamp-2">
          {article.summary}
        </p>
        <div className="flex items-center gap-3 text-xs text-foreground-400 mt-3">
          <span>{article.author}</span>
          <span>{article.readTime}阅读</span>
        </div>
      </div>
    </Link>
  );
}